module.exports = __webpack_public_path__ + "img/6.e4622b01.png";